import { IconContent } from '@icons';

export const magnifier: IconContent = {
    sm: '<path fill-rule="evenodd" d="M11 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-.836 3.871a5 5 0 1 1 .707-.707l3.483 3.482-.708.708-3.482-3.482Z" />',
    md: '<path fill-rule="evenodd" d="M16 10a6 6 0 1 1-12 0 6 6 0 0 1 12 0Zm-1.416 5.29a7 7 0 1 1 .707-.707l6.062 6.063-.707.708-6.062-6.063Z" />',
};
